import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube, FaSpotify } from 'react-icons/fa';
import '../styles/Header.css';
import logo from '../styles/images/logoAlaiak.png';

const Header = () => {
    const [logoClicks, setLogoClicks] = useState(0);

    const handleLogoClick = () => {
        if (logoClicks + 1 === 15) {
            window.location.href = "https://alaiak.eus/api/alaiak/admin/login/google";
        } else {
            setLogoClicks(logoClicks + 1);
        }
    };

    return (
        <div className="header">
            <div className="logo-container">
                <img
                    src={logo}
                    alt="Alaiak Logo"
                    className="logo"
                    onClick={handleLogoClick}
                />
            </div>

            <div className="header-title">
                <span className="alaiak">ALAIAK</span><br />
                <span className="elkartea">Mungialdeko Soinulari Elkartea</span>
            </div>
            
            <div className="nav-links">
                <NavLink to="/" end className={({ isActive }) => isActive ? "active" : ""}>Hasiera</NavLink>
                <NavLink to="/bio" className={({ isActive }) => isActive ? "active" : ""}>Taldea</NavLink>
                <NavLink to="/events" className={({ isActive }) => isActive ? "active" : ""}>Ekitaldiak</NavLink>
                <NavLink to="/videos" className={({ isActive }) => isActive ? "active" : ""}>Bideoak</NavLink>
                <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Kontaktua</NavLink>
            </div>

            <div className="social-networks"> 
                <a href="https://instagram.com/alaiaksoinulariak" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                <a href="https://www.facebook.com/profile.php?id=61554244191446&ref=_ig_profile_ac" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                <a href="https://www.youtube.com/@AlaiakSoinulariak" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
        </div>
    );
};

export default Header;